module.exports = __webpack_public_path__ + "static/media/dijon-20.88bac4d7.jpg";